import { Box } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GenericDialog } from 'src/shared/components/organisms/genericDialog';
import { InvoiceAddressActionEnum } from 'src/shared/models/enums/invoiceAdressAction.enum';
import { InvoiceAddressActionSelector } from './invoiceAddressActionSelector';
import { InvoiceAddressHandleModalCreate } from './invoiceAddressHandleModalCreate';
import { InvoiceAddressHandleModalEdit } from './invoiceAddressHandleModalEdit';
import { InvoiceAddressHandleModalFromRegister } from './invoiceAddressHandleModalFromRegister';
import { Member } from '../../models/member';

type InvoiceAddressHandleModalProps = {
  modalOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  member: Member;
};

export const InvoiceAddressHandleModal = (props: InvoiceAddressHandleModalProps) => {
  const { modalOpen, onClose, onSave, member } = props;
  const { t } = useTranslation();

  const [selectedActionType, setSelectedActionType] = useState<number | undefined>();

  const onHandleClose = () => {
    onClose();
    setSelectedActionType(undefined);
  };

  const onHandleSave = () => {
    onSave();
  };
  const onHandleStartOver = () => {
    setSelectedActionType(undefined);
  };
  return (
    <>
      <GenericDialog
        open={modalOpen && !selectedActionType}
        onClose={onHandleClose}
        onSave={onHandleSave}
        dialogTitle={t('member:invoiceAddress.handle')}
        showDialogActions={false}
        padding={0}
        dialogContent={
          <Box p={4}>
            <Box
              sx={{
                position: 'relative',
                minHeight: '15rem',
              }}
            >
              <InvoiceAddressActionSelector
                invoiceAddressId={member.invoiceAddress_id}
                selectedActionType={selectedActionType}
                setSelectedActionType={setSelectedActionType}
              />
            </Box>
          </Box>
        }
      />
      {member.member_id && selectedActionType && selectedActionType === InvoiceAddressActionEnum.CreateNew && (
        <InvoiceAddressHandleModalCreate
          memberId={member.member_id}
          modalOpen={!!selectedActionType}
          onStartOver={onHandleStartOver}
          onClose={onHandleClose}
        />
      )}
      {selectedActionType && selectedActionType === InvoiceAddressActionEnum.FromRegister && (
        <InvoiceAddressHandleModalFromRegister
          modalOpen={!!selectedActionType}
          onStartOver={onHandleStartOver}
          onClose={onHandleClose}
          member={member}
        />
      )}
      {selectedActionType && selectedActionType === InvoiceAddressActionEnum.EditExisting && (
        <InvoiceAddressHandleModalEdit modalOpen={!!selectedActionType} onClose={onHandleClose} onStartOver={onHandleStartOver} member={member} />
      )}
    </>
  );
};
